<div class="dropdown" (mouseleave)="closeDropdown()">
  <button
    class="btn btn-secondary dropdown-toggle invd-dashboard__select"
    type="button"
    id="dropdownMenu1"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isDropdownOpen"
  >
    See All Deals
    <div class="dashboard-select__icon">
      <span class="caret"></span>
    </div>
  </button>
  <ul class="dropdown-menu" [ngClass]="{ show: isDropdownOpen }">
    <li><a class="dropdown-item" href="#">Deal 1</a></li>
    <li><a class="dropdown-item" href="#">Deal 2</a></li>
    <li><a class="dropdown-item" href="#">Deal 3</a></li>
  </ul>
</div>
